import brandingConfig from './branding.json';

export default {
    mainColor: {
        color: brandingConfig.mainBrandColor,
    },
    fontColor: {
        color: brandingConfig.fonts.main,
    },
    backgrounds: {
        main: {
            backgroundColor: brandingConfig.backgrounds.main,
            color: brandingConfig.fonts.main,
        },
        header: {
            backgroundColor: brandingConfig.backgrounds.header,
            color: brandingConfig.fonts.header,
        },
        panel: {
            backgroundColor: brandingConfig.backgrounds.panel,
            color: brandingConfig.fonts.main,
        },
        panelHeader: {
            backgroundColor: brandingConfig.backgrounds.panelHeader,
            color: brandingConfig.fonts.panelHeader,
        },
        panelSecondary: {
            backgroundColor: brandingConfig.backgrounds.panelSecondary,
            color: brandingConfig.fonts.main,
        },
        menu: {
            backgroundColor: brandingConfig.backgrounds.menu,
            color: brandingConfig.fonts.main,
        },
        input: {
            backgroundColor: brandingConfig.backgrounds.inputs,
            color: brandingConfig.fonts.main,
            border: 'none',
        },
    },
    buttons: {
        primary: {
            backgroundColor: brandingConfig.mainBrandColor,
            color: brandingConfig.fonts.button,
            border: 'none',
        },
        default: {
            backgroundColor: brandingConfig.backgrounds.menu,
            color: brandingConfig.fonts.main,
            border: 'none',
        },
    },
    navItemActive: {
        color: brandingConfig.fonts.main,
        backgroundColor: brandingConfig.selectedColor,
        borderBottom: `inset 2px ${brandingConfig.mainBrandColor}`,
    },
};



/** WEBPACK FOOTER **
 ** ./src/branding/brandingStyles.js
 **/